import { createSelector } from '@reduxjs/toolkit'
import { AppState } from '../appState'

export const getCurrentShop = createSelector(
  (state: AppState) => state.shop[state.client.currentShopId],
  shop => shop,
)
